/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { Button } from "components/ui/button";
import { ContentContainer, PageLayout, PageTitle } from "components/layout";
import { Load } from "components/load";
import PageError from "components/page-error";
import { AlertTriangle } from "lucide-react";
import { IoRefresh } from "react-icons/io5";
import { IEvidenceRegister } from "src/@types/evidence-register";
import Table from "../components/table";
import CardMobile from "../components/card-mobile";
import { useColumns } from "./columns";
import { useEvidenceRegister } from "./use-evidence-register";

export const EvidenceRegister: React.FC = () => {
  const {
    methods,
    control,
    validateForm,
    divergenceData,
    displayStoreCode,
    formattedConciliationDate,
    hasReviewNotes,
    isLoading,
    isFetching,
    isSubmitting,
    isDisabledButton,
    isClosed,
    queryError,
    refetch,
    handleFinalizeEvidence,
  } = useEvidenceRegister();

  const columns = useColumns({
    control,
    methods,
    formValidate: validateForm,
    hasReviewNotes,
  });

  if (isLoading) return <Load />;
  if (queryError) return <PageError status={500} message="ERRO INTERNO NO SERVIDOR" />;
  if (isClosed) return <Load />;

  return (
    <PageLayout>
      <div className="flex-1 w-full flex justify-between items-start">
        <div>
          <PageTitle
            title="Conferência de Caixas"
            description={`Loja ${displayStoreCode}`}
          />
          <p className="text-muted-foreground text-sm mt-1">
            Identificamos divergências na conciliação de caixa{" "}
            {displayStoreCode || "da loja"}. Verifique a tabela abaixo e forneça
            as evidências necessárias.
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <div className="text-sm text-right">
            <span className="font-bold">Conciliação:</span>{" "}
            {formattedConciliationDate}
          </div>
          <span
            className={`flex items-center gap-1.5 text-[#3c7dd9] text-sm cursor-pointer hover:underline ${isFetching ? "cursor-not-allowed" : ""}`}
            onClick={refetch}
          >
            <IoRefresh className={`text-lg ${isFetching ? "animate-spin" : ""}`} />
            Recarregar
          </span>
        </div>
      </div>
      <ContentContainer>
        <div className="hidden w-full md:flex flex-col">
          <Table
            columns={columns}
            data={divergenceData as unknown as IEvidenceRegister[]}
            isFetching={isFetching}
          />
        </div>
        <div className="flex flex-col gap-3 w-full md:hidden">
          {divergenceData.map((item: any, index: number) => (
            <CardMobile
              key={item?.id ?? index}
              methods={methods}
              description={item?.name}
              id={item?.id as number}
              price={item?.amount as unknown as number}
              coment={item?.analyst_comments as string}
              justification={item?.store_justification as string}
              entity_name="divergence"
              version={item?.version}
              formValidate={validateForm}
              reviewNotes={
                hasReviewNotes
                  ? (item?.review_info?.review_notes ?? null)
                  : undefined
              }
            />
          ))}
        </div>
        <div className="mt-3 p-3 bg-yellow-50 border border-yellow-200 rounded-md">
          <p className="text-sm flex items-center gap-1.5">
            <AlertTriangle className="h-4 w-4 text-yellow-600" />
            <span className="font-medium text-yellow-700">Atenção:</span>
            <span className="text-gray-700">
              Se atentar com OS CAMPOS OBRIGATÓRIOS
            </span>
          </p>
        </div>
        <div className="flex w-full justify-end pt-4">
          <Button
            isLoading={isSubmitting}
            variant="default"
            onClick={handleFinalizeEvidence}
            disabled={isDisabledButton || isSubmitting}
          >
            Salvar
          </Button>
        </div>
      </ContentContainer>
    </PageLayout>
  );
};
